import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionLabAI from '../../components/LabAI/IntroSectionLabAI/IntroSectionLabAI';
import ServicesCardsLabAI from '../../components/LabAI/ServicesCardsLabAI/ServicesCardsLabAI';
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import Navbar from "../../components/Common/Navbar/Navbar";
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ServiceList from '../../components/CyberAudit/ServicesSliderCyberData/ServicesSliderCyberData';
import ParallaxComponent from '../../components/Common/ParallaxBackground/ParallaxComponent';
import auditCyberParallaxText from '../../components/Common/ParallaxBackground/auditCyberParallaxText';
import ParallaxIMG0 from './../../assets/images/itmonkeys-cyber-img-p0.png';
import ParallaxIMG1 from './../../assets/images/itmonkeys-cyber-img-p1.png';
import ParallaxIMG2 from './../../assets/images/itmonkeys-cyber-img-p2.png';
import ExpertiseSection from '../../components/CyberAudit/ExpertiseSectionCyberAudit/ExpertiseSectionCyberAudit';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData15 from '../../components/Common/IntroSectionBottom/introSectionData15';
import useSectionRefs from '../../hooks/useSectionRefs';
import ServicesDataBenefits from '../../components/LabAI/ServicesSliderLabAI/ServicesSliderLabAI';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import Timeline from '../../components/CyberAudit/Timeline/TimelinePrivateCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
const LabAI: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();

    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('labAI.header.title', 'AI Lab')} 
            subtitle={t('labAI.header.subtitle', "L'Innovation par l'Intelligence Artificielle")} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionLabAI />
        <IntroSectionBottom data={introSectionData15} translationNamespace="labAI" />
      </section>
      <div className="gradient-bg">
      <section id="start2" className="section dark" ref={sectionRefs.start2}>
      <ParallaxComponent
        images={{
          layer1: ParallaxIMG0,
          layer2: ParallaxIMG1,
          layer3: ParallaxIMG2,
        }}
        textContent={auditCyberParallaxText}
        contentBelowParallax={<ExpertiseSection />}
        wrapperClassName="parallax__wrapper_labai"
        translationNamespace="labAI"
        />
          <ServicesDataBenefits />
          <Timeline />
          <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
        </section>
      </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="labAI" />
      <Footer />
      </section>
    </div>
  );
};

export default LabAI;
